import React from "react";
import { useEffect, useState } from "react";
import downoutline from "../images/downoutline.svg";
import styled from "styled-components";
import { Button } from "../UI";
import { shortenAddress } from "../utils/shortenAddress";
import { Popover } from "antd";
import "./styles/TokenHistory.scss";

const HistoryWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  margin: 50px auto;
  background: #ffffff;
  border: 1.38736px solid rgba(169, 169, 169, 0.54);
  border-radius: 21.6925px;
  position: relative;

  .historyInner {
    padding: 30px 20px;
  }

  .searchBar {
    width: 411px;
    height: 52px;
    border: 1px solid #e6eef9;
    background: #e6eef9;
    box-shadow: inset 1.3833px 1.3833px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5.77909px;
    outline: none;
    padding: 0px 20px;
  }

  .action-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
  }

  .sort_dropDown {
    position: absolute;
    width: 137px;
    height: 85px;
    background: #ffffff;
    box-shadow: -1px -1px 2px rgba(0, 0, 0, 0.08),
      2px 2px 2px rgba(0, 0, 0, 0.13);
    border-radius: 7px;
    padding: 10px 8px;
    top: 107px;
    right: 15px;
  }

  .sort {
    font-family: "Public Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #808080;
    padding: 5px 6px;
  }

  .sort_active {
    color: #808080;
    background: #dbeaff;
    border-radius: 3.77769px;
    display: flex;
    align-items: center;
  }

  .searchBar::placeholder {
    font-family: "Public Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #808080;
  }

  .historyInnerContentsHeaders ul {
    display: grid;
    grid-template-columns: 150px 100px 100px 100px 100px 100px;
  }

  .historyInnerContentsHeaders ul li {
    font-family: "Public Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    color: #000000;
  }

  .historyInner hr {
    border: 0.8px solid rgba(169, 169, 169, 0.5);
    margin-top: 20px;
  }

  .historyInnerContents ul {
    .pools {
      position: relative;
    }

    .token,
    .type,
    .amount,
    .txid {
      font-weight: 600;
      color: #000000;
      cursor: pointer;
      a{
        color: #000000;
      }
    }
    .complete {
      font-weight: 600;
      color: green;
    }

    .error {
      font-weight: 600;
      color: red;
    }
  }

  .historyInnerContents ul {
    display: grid;
    grid-template-columns: 150px 100px 100px 100px 100px 100px;
  }

  .historyInnerContents li {
    font-family: "Public Sans";
    font-style: normal;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    justify-content: justify;
    color: #000000;
    padding: 20px 0px;
  }

  .historyInnerContents .pools {
    display: flex;
    align-items: center;
  }

  .historyInnerContents .pools img {
    width: 31px;
    height: 31px;
    margin-right: 10px;
  }

  .historyInnerContents .pools .logo2 {
    position: absolute;
    left: 15px;
  }

  .table_head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
    span {
      &:first-child {
        width: 200px;
      }
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #000000;
    }
  }
  .table_content {
    display: flex;
    justify-content: space-between;

    span {
      &:first-child {
        width: 200px;
      }
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #000000;
    }
  }
  .sort_dropDown {
    border: 1px solid red;
  }
`;

const SortPopover = styled.div`
  width: 110px;
  p {
    width: 100%;
    padding: 10px;
    font-weight: 400;
    font-size: 12px;
    line-height: 10px;
    color: #808080;
    margin: 5px 0px;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background-color: #dbeaff;
    }
  }
`;

export default function TokenHistory() {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const SortPopoverContent = () => {
    return (
      <SortPopover>
        <p>Sort by date</p>
        <p>Sort by Tnx</p>
      </SortPopover>
    );
  };
  return (
    <HistoryWrapper>
      <div>
        <div className="historyInner">
          <div className="historyInner">
            <div className="action-buttons">
              <div>
                <input
                  type="text"
                  placeholder="Search Tnx"
                  className="searchBar"
                />
              </div>

              <div>
                <Popover
                  content={<SortPopoverContent />}
                  overlayClassName="sort_dropDown"
                  trigger="click"
                  placement="bottom"
                  visible={visible}
                  onVisibleChange={handleVisibleChange}
                >
                  <Button className="style-historyBtn dropDownBtn">
                    Sort By <img src={downoutline} alt="logo" />{" "}
                  </Button>
                </Popover>
              </div>
            </div>
            <div className="table_head">
              <span>Pools</span>
              <span>TVL</span>
              <span>Borrowed</span>
              <span>Lend APY</span>
              <span>Borrow APY</span>
              <span>LTV</span>
              <span>Vol24</span>
              <span>Vol24</span>
            </div>
            <div className="table_content">
              <span>Pools</span>
              <span>TVL</span>
              <span>Borrowed</span>
              <span>Lend APY</span>
              <span>Borrow APY</span>
              <span>LTV</span>
              <span>Vol24</span>
              <span>Vol24</span>
            </div>
          </div>
        </div>
      </div>
    </HistoryWrapper>
  );
}
